import util from '@/util';
import CanvasUtil from '@/CanvasUtil';
import fileService from '../../../request/service/fileupload-service.js';
export default{
    async createFontCover(fontUrl, fontName) {
        let effectiveFont = await util.downloadFont(fontName, fontUrl).catch(() => {});
        if (!effectiveFont) {
            return Promise.reject('不支持该字体');
        }
        let layerList = [
            {
                name: '自助设计字体',
                type: 'text',
                fontFamily: fontName,
                color: '#000',
                textAlign: 'center',
                fontSize: 20,
                lineHeight: 14,
                left: 0,
                top: 38,
                width: 180,
                height: 25,
            },
            {
                name: 'ABCDEFG1234567890',
                type: 'text',
                fontFamily: fontName,
                color: '#000',
                textAlign: 'center',
                fontSize: 12,
                lineHeight: 12,
                left: 0,
                top: 64,
                width: 180,
                height: 18
            }
        ];
        let base64 = await CanvasUtil.toCanvas('rgba(0,0,0,0)', 180, 120, layerList).catch((error) => {
            console.error(error);
        });
        if (base64) {
            let {url} = await fileService.uploadFileByBase64(base64).catch((error) => {
                console.error(error);
                return Promise.reject('字体封面生成失败');
            });
            return Promise.resolve(url);
        }
        return Promise.resolve(false);
    },
    async createFontView (fontUrl, fontName, text) {
        let effectiveFont = await util.downloadFont(fontName, fontUrl).catch(() => {});
        if (!effectiveFont) {
            return Promise.reject('不支持该字体');
        }
        let layerList = [
            {
                name: text,
                type: 'text',
                fontFamily: fontName,
                color: '#000',
                textAlign: 'left',
                fontSize: 28,
                lineHeight: 32,
                left: 0,
                top: 0,
                width: 360,
                height: 32,
            }
        ];
        let base64 = await CanvasUtil.toCanvas('rgba(0,0,0,0)', 360, 32, layerList).catch((error) => {
            console.error(error);
        });
        if (base64) {
            let {url} = await fileService.uploadFileByBase64(base64).catch((error) => {
                console.error(error);
                return Promise.reject('字体封面生成失败');
            });
            return Promise.resolve(url);
        }
        return Promise.resolve(false);
    }
}